import React, { useCallback } from "react";
import { Button, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { AppLanguage, SUPPORTED_LANGUAGES, resolveAppLanguage } from "./index";

const SHORT_LABELS: Record<AppLanguage, string> = {
  en: "EN",
  nl: "NL",
};

export function LanguageToggle() {
  const { t, i18n } = useTranslation();
  const language = resolveAppLanguage(i18n.language);

  const cycleLanguage = useCallback(() => {
    const index = SUPPORTED_LANGUAGES.indexOf(language);
    const next = SUPPORTED_LANGUAGES[(index + 1) % SUPPORTED_LANGUAGES.length];
    void i18n.changeLanguage(next);
  }, [i18n, language]);

  const languageName = t(`language.${language}`);

  return (
    <Tooltip
      title={t("language.tooltip", { language: languageName })}
      placement="left"
    >
      <Button
        className="Language-toggle"
        shape="circle"
        size="large"
        aria-label={t("language.ariaLabel", { language: languageName })}
        onClick={cycleLanguage}
      >
        <span className="Language-toggle__code" aria-hidden>
          {SHORT_LABELS[language]}
        </span>
      </Button>
    </Tooltip>
  );
}
